module.exports = __webpack_public_path__ + "img/IMG_8981_L_Wood.48358977.jpg";